export const REGISTER = 'REGISTER';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';

export const REQUEST_RESET_EMAIL = 'REQUEST_RESET_EMAIL';
export const REQUEST_RESET_EMAIL_SUCCESS = 'REQUEST_RESET_EMAIL_SUCCESS';
export const REQUEST_RESET_EMAIL_ERROR = 'REQUEST_RESET_EMAIL_ERROR';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const LOAD_USER = 'LOAD_USER';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_ERROR = 'LOAD_USER_ERROR';
export const AUTH_ERROR = 'AUTH_ERROR';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
// Sign in with an emailed code (success/error are LOGIN_USER_*).
export const LOGIN_WITH_CODE = 'LOGIN_WITH_CODE';

export const LOGOUT = 'LOGOUT';

export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';

export const OPEN_AUTH_MODAL = 'OPEN_AUTH_MODAL';

export const SET_IS_LOGIN = 'SET_IS_LOGIN';

export const SET_AUTH_FLOW_CONTEXT = 'SET_AUTH_FLOW_CONTEXT';
export const CLEAR_AUTH_FLOW_CONTEXT = 'CLEAR_AUTH_FLOW_CONTEXT';

// Free Trial Constants
export const GET_FREE_TRIAL_STATUS = 'GET_FREE_TRIAL_STATUS';
export const GET_FREE_TRIAL_STATUS_SUCCESS = 'GET_FREE_TRIAL_STATUS_SUCCESS';
export const GET_FREE_TRIAL_STATUS_ERROR = 'GET_FREE_TRIAL_STATUS_ERROR';
export const REDEEM_FREE_TRIAL = 'REDEEM_FREE_TRIAL';
export const REDEEM_FREE_TRIAL_SUCCESS = 'REDEEM_FREE_TRIAL_SUCCESS';
export const REDEEM_FREE_TRIAL_ERROR = 'REDEEM_FREE_TRIAL_ERROR';
